import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './helpers/store';
import ReactDOM from "react-dom/client";
import { fakeBackend } from './helpers/fake-backend';
import { create } from "jss";
// react-perfect-scrollbar component
import PerfectScrollbar from "react-perfect-scrollbar";
import rtl from "jss-rtl";
import {
  StylesProvider,
  jssPreset
} from "@material-ui/core/styles";

fakeBackend();
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <Provider store={store}>

    <BrowserRouter>
      <PerfectScrollbar>
        <App />
      </PerfectScrollbar>
    </BrowserRouter>
    
  </Provider>

);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
